import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { EventListenerProps } from "./interfaces";

const EventListener: FC<EventListenerProps> = ({
    id,
    tag,
    onOpen,
    onClose,
}) => {
    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        const handleOpenDiscovery = (event: Event) => {
            if (!(event instanceof CustomEvent)) {
                return;
            }

            const targetTag = event.detail.tag;
            const targetId = event.detail.id;

            if (typeof targetTag !== "string" || tag !== targetTag) {
                return;
            }

            let doOpen = false;

            if (typeof targetId === "string" && targetId) {
                doOpen = id === targetId;

                if (!doOpen) {
                    const el = document.querySelector(
                        `[data-discovery-item="${targetId}"]`,
                    );

                    if (!el) {
                        doOpen = true;
                    }
                }
            } else {
                doOpen = true;
            }

            if (doOpen) {
                // in order to prevent opening multiple popovers of the same tag
                //
                event.stopImmediatePropagation();
                onOpen();
            }
        };

        const handleCloseHistory = () => {
            onClose();
        };

        const handleItemOpened = (event: Event) => {
            if (!(event instanceof CustomEvent)) {
                return;
            }

            const targetId = event.detail.id;

            if (typeof targetId === "string" && id !== targetId) {
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeydown);
        window.addEventListener(
            "discovery.open_discovery",
            handleOpenDiscovery,
        );
        window.addEventListener("discovery.close-history", handleCloseHistory);
        window.addEventListener("discovery.item_opened", handleItemOpened);

        return () => {
            document.removeEventListener("keydown", handleKeydown);
            window.removeEventListener(
                "discovery.open_discovery",
                handleOpenDiscovery,
            );
            window.removeEventListener(
                "discovery.close-history",
                handleCloseHistory,
            );
            window.removeEventListener(
                "discovery.item_opened",
                handleItemOpened,
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tag]);

    return null;
};

export default EventListener;
